<template>
<CreateWorkFlow />
</template>

<script>
import CreateWorkFlow from '@/components/3pl/Settings/Approval/CreateWorkFlow/index'
export default {
components:{
    CreateWorkFlow
}
}
</script>

<style>

</style>